// components/FileAttachment.jsx
import React from 'react';
import { useFileLoader } from '../../hooks/useFileLoader';

function FileAttachment({ 
    mediaUrl, 
    fileName, 
    className = '', 
    onClick
   
}) {
    const { fileUrl, loading, error } = useFileLoader(mediaUrl);

    if (loading) {
        return (
            <div className="file-loading">
                <div className="spinner"></div>
            </div>
        );
    }

    if (error || !fileUrl) {
        return (
            <div className="file-error">
                <span>📄 {fileName || 'Файл'}</span>
                <span className="error-text"> Не найден</span>
            </div>
        );
    }

 

    // Определяем тип по расширению или по заголовкам
    const isImage = fileUrl.match(/\.(jpeg|jpg|gif|png|webp|svg|bmp|ico)$/i) || 
                    mediaUrl?.match(/\.(jpeg|jpg|gif|png|webp|svg|bmp|ico)$/i);
    const isVideo = fileUrl.match(/\.(mp4|webm|ogg|avi|mov|mkv)$/i) || 
                    mediaUrl?.match(/\.(mp4|webm|ogg|avi|mov|mkv)$/i);

    if (isImage) {
        return (
           
            <img 
                src={fileUrl} 
                alt={fileName || 'Image'} 
                className={`file-attachment image ${className}`}
                onClick={onClick}
                loading="lazy"               
            />
            
        );
    }

    if (isVideo) {
        return (
            <video 
                src={fileUrl} 
                controls 
                className={`file-attachment video ${className}`}
                onClick={onClick}
            />
        );
    }

    // Для остальных файлов - ссылка на скачивание
    return (
        <a 
            href={fileUrl} 
            download={fileName || 'file'} 
            className={`file-attachment download ${className}`}
            onClick={onClick}
        >
            <span className="file-icon">📎</span>
            <span className="file-name">{fileName || 'Скачать файл'}</span>
        </a>
    );
}

export default FileAttachment;